import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form,Row, Col, Input, Select,Button,   TimePicker, message} from "antd"; // Ant Design Components
import moment from "moment";

const { Option } = Select;

function DoctorForm({ onFinish, initivalValues }) {
  const [services, setServices] = useState([]);
  const [locations, setLocations] = useState([]);
  const [specialitys, setSpecialitys] = useState([]);
  const [totalSlots, setTotalSlots] = useState([]);
  const format = "HH:mm";
  const [clinicDays, setClinicDays] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  


  useEffect(() => {
    // ✅ Fetch clinic days dynamically from the backend
    axios.get("/api/user/get-all-clinic-day").then((res) => {
      if (res.data.success) {
        setClinicDays(res.data.clinicDays);
      } else {
        message.error("Failed to load clinic days");
      }
    }).catch(() => {
      message.error("Error fetching clinic days");
    });
  }, []);






  useEffect(() => {
    const getServiceData = async () => {
      try {
        const response = await axios.get("/api/user/get-all-services", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.success) {
          setServices(response.data.data);
        }

      } catch (error) {
        console.log(error);
      }
    };
    getServiceData();
  }, []);

  useEffect(() => {
    const getLocationData = async () => {
      try {
        const response = await axios.get("/api/user/get-all-location", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.success) {
          setLocations(response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getLocationData();
  }, []);

  useEffect(() => {
    const getSpecialityData = async () => {
      try {
        const response = await axios.get("/api/user/get-all-speciality", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.success) {
          setSpecialitys(response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getSpecialityData();
  }, []);

  useEffect(() => {
    const getTotalSlotsData = async () => {
      try {
        const response = await axios.get("/api/Appointmentslot/get-all-totalSlots", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        if (response.data.success) {
          setTotalSlots(response.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getTotalSlotsData();
  }, []);

  const validateTiming = (rule, value) => {
    if (
      value &&
      value[0] &&
      value[1] &&
      value[0].format(format) !== "00:00" &&
      value[1].format(format) !== "00:00"
    ) {
      return Promise.resolve();
    }
    return Promise.reject("Please select valid time of appointment");
  };



  return (
    <Form
      layout="vertical"
      className="formFactor"
      onFinish={onFinish}
      initialValues={{
        ...initivalValues,
        ...(initivalValues && {
          appointmentTime: [
            moment(initivalValues?.appointmentTime[0], "HH:mm"),
            moment(initivalValues?.appointmentTime[1], "HH:mm"),
          ],
          
        }),

      }}
    >
      <Row gutter={20}>
        <Col span={8} xs={24} sm={24} lg={24}>
          <Form.Item
            label="Service"
            name="service"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select a service">
              {services.map((service) => (
                <Option key={service.service} value={service.service}>
                  {service.service}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <hr />
      <h3 className="card-title mt-3">Doctor Information</h3>
      <Row gutter={20}>
        <Col span={8} xs={24} sm={24} lg={8}>
          <Form.Item
            required
            label="First Name"
            name="firstName"
            rules={[{ required: true }]}
          >
            <Input placeholder="First Name" />
          </Form.Item>
        </Col>

        <Col span={8} xs={24} sm={24} lg={8}>
          <Form.Item
            required
            label="Last Name"
            name="lastName"
            rules={[{ required: true }]}
          >
            <Input placeholder="Last Name" />
          </Form.Item>
        </Col>

        <Col span={8} xs={24} sm={24} lg={8}>
          <Form.Item
            required
            label="Email"
            name="email"
            rules={[{ required: true }]}
          >
            <Input placeholder="Email Address" />
          </Form.Item>
        </Col>

        <Col span={8} xs={24} sm={24} lg={8}>
          <Form.Item
            required
            label="Phone Number"
            name="phoneNumber"
            rules={[{ required: true }]}
          >
            <Input placeholder="Phone Number" />
          </Form.Item>
        </Col>

        <Col span={8} xs={24} sm={24} lg={8}>
          <Form.Item
            required
            label="Location"
            name="location"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select a Location">
              {locations.map((location) => (
                <Option key={location.location} value={location.location}>
                  {location.location}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8} xs={24} sm={24} lg={8}>
          <Form.Item
            required
            label="Appointment Slots"
            name="totalSlots"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select Slots">
              {totalSlots.map((totalSlots) => (
                <Option key={totalSlots.totalSlots} value={totalSlots.totalSlots}>
                  {totalSlots.totalSlots}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <hr />
      <h3 className="card-title mt-3">Professional Information</h3>
      <Row gutter={20}>
        <Col span={8} xs={24} sm={24} lg={8}>
          <Form.Item
            required
            label="Specialization"
            name="specialization"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select a Specialization">
              {specialitys.map((speciality) => (
                <Option
                  key={speciality.speciality}
                  value={speciality.speciality}
                >
                  {speciality.speciality}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8} xs={24} sm={24} lg={8}>
          <Form.Item
            required
            label="Experience"
            name="experience"
            rules={[{ required: true }]}
          >
            <Input placeholder="Experience" type="number" />
          </Form.Item>
        </Col>
        <Col span={8} xs={24} sm={24} lg={8}>
          <Form.Item
            required
            label="Consultation Fee"
            name="feePerConsultation"
            rules={[{ required: true }]}
          >
            <Input placeholder="Consultation Fee" type="number" />
          </Form.Item>
        </Col>

        <Col span={8} xs={24} sm={24} lg={8}>
          <Form.Item
            required
            label="Appointment Timing"
            name="appointmentTime"
            rules={[{ validator: validateTiming }]}
          >
            <TimePicker.RangePicker format={format} className="mt-3" />
          </Form.Item>
        </Col>

        <Col span={8} xs={24} sm={24} lg={12}>
                <Form.Item
                  label="Choose Clinic Days"
                  name="clinicDay"
                  rules={[{ required: true }]}>
                <Select
                mode="multiple"
                allowClear
                placeholder="Select clinic days"
                value={selectedDays}
                onChange={setSelectedDays}
                style={{ width: "100%" }}
                dropdownStyle={{ maxHeight: 400, overflowY: "auto" }} 
                className="mt-3" >
                {clinicDays.map((day) => (
                  <Option key={day.name} value={day.name}>
                    {day.name}
                  </Option>
                ))}
              </Select>
                </Form.Item>
                </Col>

      </Row>
      <div className="d-flex justify-content-end">
        <Button type="ant-btn-botton-primary" htmlType="submit">
          SUBMIT
        </Button>
      </div>
    </Form>
  );
}

export default DoctorForm;
